import iconTelWh from "../../../../assets/icon_tel_wh.svg";
import CustomModal from "../../../../components/Modal/CustomModal";
import useReactGASend from "../../../../hooks/useReactGASend";
import { sanitizeTelNumber } from "../../../../utils";
import { validateTelNumber } from "#src/utils/validateTelNumber.js";

const VoiceAgent = ({ isOpen, onRequestClose, transferNumber }) => {
  const { makeEventTrackFn } = useReactGASend();
  const sanitizedTel = sanitizeTelNumber(transferNumber);
  const telHref = sanitizedTel ? `tel:${sanitizedTel}` : null;

  const handleVoiceAgentClick = () => {
    if (!validateTelNumber(transferNumber)) return;
    
    makeEventTrackFn({
      category: "event",
      action: "상담사 전화 연결(상담사 전화 연결)",
      body: { data_btn_nm: "상담사 전화 연결(상담사 전화 연결)" },
    });
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="디지털상담 음성 이관"
      btnClose
    >
      <p className="text-2xl font-semibold text-center mb-2.5">
        음성 상담원 연결을 위해
        <br />
        아래 버튼을 눌러주세요.
      </p>
      <p className="mb-8 text-lg font-medium text-center text-neutral-400">
        채팅 상담원 연결이 종료되었습니다.
      </p>
      {telHref && (
        <a
          href={telHref}
          onClick={handleVoiceAgentClick}
          className="flex items-center justify-center gap-7 w-full font-semibold text-white bg-purple-700 rounded-2xl h-[52px]"
        >
          <img src={iconTelWh} alt="" />
          음성 상담원 연결
        </a>
      )}
    </CustomModal>
  );
};

export default VoiceAgent;
